import {HabitationMonitoringService} from "../../../serverService/habitationMonitoring/HabitationMonitoringService";
import React, {useEffect, useState} from "react";
import {
    RaikoBaseCardContainer,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator, RaikoFlexAlignStart,
    RaikoGridOneColumn, RaikoLabel,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {chartColors} from "../../../component/charts/utils/ChartColors";
import PieChartWithPaddingAngle, {
    preparePieChartItem
} from "../../../component/charts/pieChartWithPaddingAngle/PieChartWithPaddingAngle";
import PieChartLineInfo from "../../../component/charts/pieChartWithPaddingAngle/pieChartLineInfo/PieChartLineInfo";
import {css} from "@emotion/css";
import RaikoSegmentSelect, {
    raikoSegmentSelectItemGenerator
} from "../../../raikoComponents/raikoSegmentSelect/RaikoSegmentSelect";

export default function HabitationMonitoringPieChartAccommodationRequest({periodId, refreshFlag = false}) {


    const service = new HabitationMonitoringService()


    const [accommodationReserveData, setAccommodationReserveData] = useState({})
    const [accommodationReserveFilters, setAccommodationReserveFilters] = useState([
        raikoCustomSelectItemGenerator("REQUEST", "درخواست ها"),
        raikoCustomSelectItemGenerator("COUPLE", "آقایان | خانم ها"),
        raikoCustomSelectItemGenerator("MAN", "آقایان"),
        raikoCustomSelectItemGenerator("WOMAN", "خانم ها")
    ])
    const accommodationReserveFilterKey = {
        "REQUEST": "numberOfRequest",
        "COUPLE": "totalPeople",
        "MAN": "numberOfMen",
        "WOMAN": "numberOfWomen"
    }

    const [selectedAccommodationReserve, setSelectedAccommodationReserve] = useState(accommodationReserveFilters[0].id)

    function getDataFromServer() {
        service.getAccommodationRequestsStatus(periodId)
            .then(response => {
                const _habitation = []
                const _couple = []
                const _men = []
                const _women = []


                const colors = [
                    chartColors.pink,
                    chartColors.green,
                    chartColors.orange,
                    chartColors.red,
                    chartColors.cyan,
                    chartColors.gold
                ]

                response.items.map((item, index) => {
                    _habitation.push(
                        preparePieChartItem(
                            item.title,
                            item[accommodationReserveFilterKey[accommodationReserveFilters[0].id]],
                            colors[(index) % 6]
                        )
                    )
                    _couple.push(
                        preparePieChartItem(
                            item.title,
                            item[accommodationReserveFilterKey[accommodationReserveFilters[1].id]],
                            colors[(index) % 6]
                        )
                    )
                    _men.push(
                        preparePieChartItem(
                            item.title,
                            item[accommodationReserveFilterKey[accommodationReserveFilters[2].id]],
                            colors[(index) % 6]
                        )
                    )
                    _women.push(
                        preparePieChartItem(
                            item.title,
                            item[accommodationReserveFilterKey[accommodationReserveFilters[3].id]],
                            colors[(index) % 6]
                        )
                    )
                })

                setAccommodationReserveData(
                    {
                        REQUEST: _habitation,
                        COUPLE: _couple,
                        MAN: _men,
                        WOMAN: _women,
                    }
                )

            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {

        })
    }

    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId >= 0) {
            getDataFromServer()
        }
    }, [periodId]);

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag) {
            getDataFromServer()
        }
    }, [refreshFlag]);


    return <>
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoFlexAlignStart className={css`align-items: center;`}>
                    <RaikoLabel
                        text={"درخواست ها"}
                        className={css`
                            white-space: nowrap;
                            flex-grow: 1;
                            width: 50%;`}
                    />
                    <RaikoSegmentSelect
                        value={selectedAccommodationReserve}
                        setValue={setSelectedAccommodationReserve}
                    items={[
                        raikoSegmentSelectItemGenerator("REQUEST", "درخواست"),
                        raikoSegmentSelectItemGenerator("COUPLE", "آقا/خانم"),
                        // raikoSegmentSelectItemGenerator("MAN", "آقا"),
                        // raikoSegmentSelectItemGenerator("WOMAN", "خانم")
                    ]}
                    />
                    {/*<RaikoCustomSelect*/}
                    {/*    labelText={"فیلتر"}*/}
                    {/*    value={selectedAccommodationReserve}*/}
                    {/*    setValue={setSelectedAccommodationReserve}*/}
                    {/*    items={accommodationReserveFilters}*/}
                    {/*/>*/}
                </RaikoFlexAlignStart>
                <RaikoGridOneColumn>
                    <PieChartWithPaddingAngle
                        data={accommodationReserveData[selectedAccommodationReserve]}
                    />
                    <RaikoGridOneColumn>
                        {accommodationReserveData && accommodationReserveData[selectedAccommodationReserve] ?
                            accommodationReserveData[selectedAccommodationReserve].map((item, index) => {
                                return <PieChartLineInfo
                                    color={item.color}
                                    value={item.value}
                                    title={item.label}
                                />
                            }) : ""}
                    </RaikoGridOneColumn>

                </RaikoGridOneColumn>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    </>


}